import type { Field } from '@/modules/Project/Fields/types'
import { computed, type Ref } from 'vue'

/**
 * This composable returns true if a field is not computing because its property
 * has no inputs.
 */
export const useIsWaitingForInputs = (field: Ref<Field | undefined>) => {
  return computed(() => {
    if (!field.value) {
      return false
    }

    return 'reason' in field.value.staleness && field.value.staleness.reason === 'no_inputs'
  })
}
